import { render } from "./CreateUserDialog.vue?vue&type=template&id=6f7df01c&scoped=true"
import script from "./CreateUserDialog.vue?vue&type=script&lang=ts"
export * from "./CreateUserDialog.vue?vue&type=script&lang=ts"

import "./CreateUserDialog.vue?vue&type=style&index=0&id=6f7df01c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f7df01c"

export default script